<template>
  <div class="home">
    <nav class="headerHome">
    <div v-if="!isCollapse" class="logo" @click="goHome">
      <svg class="icon" aria-hidden="true" >
        <use xlink:href="#icon_logo1"></use>
      </svg>
    </div>
    <div v-else  class="logoLittle">
      <svg class="icon " aria-hidden="true" @click="goHome">
        <use xlink:href="#icon_logo21"></use>
      </svg>
    </div>
    <div class="expanDiv">
      <svg class="icon btn-expan" v-if="!isCollapse" aria-hidden="true" @click="isShowCollapse()">
        <use xlink:href="#icon_btn_expansion1"></use>
      </svg>
      <svg class="icon btn-expan" v-else aria-hidden="true" @click="isShowCollapse()">
        <use xlink:href="#icon_btn_contraction1"></use>
      </svg>
    </div>
        
      <div class="menuSelect">
        <div v-for="(item,index) in menuChoose" :key="index" :class="{'active':$route.path==item.path}" @click="menuLink(item)">
          <span>{{item.meta.title}}</span>
          <svg class="icon btn-close" aria-hidden="true" @click.stop="closeMenu(index)">
            <use xlink:href="#icon_close_normal"></use>
          </svg>
        </div>
      </div>
      <div class="userContainer">
        <el-avatar :size="32" :src="userInfo.avatar" v-if="userInfo.avatar"></el-avatar>
        <svg class="icon btn-user" aria-hidden="true" v-else>
          <use xlink:href="#icon_header_profile1"></use>
        </svg>
        <span v-text="userInfo.nickname"></span>
        <div class="modulePerson">
          <p @click="loginOut">
            <svg class="icon normal" aria-hidden="true" >
              <use xlink:href="#icon_quit-normal"></use>
            </svg>
             <svg class="icon active" aria-hidden="true" >
              <use xlink:href="#icon_quit-hover"></use>
            </svg>
            <span>退出账号</span>
          </p>
        </div>
      </div>
    </nav>
    <div class="contentShow">
      <el-menu :collapse="isCollapse" class="menu"  :default-active="$route.path ==='/welcome'?'':$route.path " :unique-opened="true">
        <component v-for="(item,index) in menuList" :key="item.path" v-show="item.meta.status==='normal'" 
        :is="(item.children&&item.children.length>0)?'el-submenu':'el-menu-item'" :index="item.path">
         <template slot="title" :index="index" v-if="item.children&&item.children.length>0"> 
            <i :class="'iconfont '+item.icon"></i>
            <span slot="title">{{item.meta.title}}</span>
          </template>
           <template  :index="index" v-else> 
            <i :class="'iconfont '+item.icon"></i>
            <span slot="title">{{item.meta.title}}</span>
          </template>
          <template v-if="item.children&&item.children.length>0" >
            <el-menu-item-group>
              <el-menu-item :class="{'is-active':$route.path==menu.path}"  v-for="(menu,idx) in item.children" :index="menu.path" :key="idx" 
              @click="menuLink(menu)" v-show="menu.meta.status == 'normal'">{{menu.meta.title}}</el-menu-item>
            </el-menu-item-group>
          </template>
        </component>
      </el-menu>
      <div :class="isCollapse?'content':'contentCollapse'"> 

        <router-view></router-view>
      </div>
    </div>
    <!-- <PersonInfo v-show="showPersonInfo"  v-on:isShowPersonInfo='isShowPersonInfo'></PersonInfo> -->
  </div>
</template>

<script>
import PersonInfo from '../components/home/PersonInfo'
import {setMenuList, hasPermission } from '../utils/index'
import router from '../router/index'
import { mapState,mapMutations } from 'vuex'
import tokenRefresh from './tokenRefresh'
import { codeLogin } from '../api/login'
// import { setMenuList, hasPermission } from './utils/index'
// import { mapMutations } from 'vuex'
import { infoGet } from '../api/user'
export default {
  data(){
    return{
      isCollapse:false,
      menuChoose:[],
      showPersonInfo:false
    }
  },
  created(){
    let curRouter = this.$route
    if(curRouter.path !=='/welcome'){
      this.menuChoose.push(curRouter)
    }
    let tokenStr = localStorage.getItem('code')
    if(tokenStr){
      this.codeLoginFunc()
    }else{
      this.getUserInfo()
    }
  },
  computed:{
     ...mapState(['userInfo','menuList']),
  }, 
  mounted(){
    // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // this.setUserinfo(userInfo)
  }, 
  methods:{
    goHome(){
      this.$router.push({path:'/welcome'})
    },
    loginOut(){
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('menuList')
      localStorage.removeItem('permission')
      let barleyUrl = JSON.parse(this.$cookie.get('barleyUrl')) 

      window.location.href = barleyUrl
      // window.location.href = sessionStorage.getItem('barleyUrl')
      // window.open(barleyUrl)
    },
    isShowPersonInfo(){
      this.showPersonInfo = !this.showPersonInfo
    },
    isShowCollapse(){
      this.isCollapse = !this.isCollapse
    },
    menuLink (child) {
      let list = this.menuChoose
      let flag = true
      for(let i =0;i<list.length;i++){
        if(list[i].path ===child.path){
          flag = false
        }
      }
      if(flag){
        this.menuChoose.push(child)
      }
      this.$router.push({path: child.path})
    },
    closeMenu(i){
      let curRouter = this.menuChoose[i]
      let curPath = this.$route.path
      if(curRouter.path == curPath ){
        if(i ==0){
          if(this.menuChoose.length>1){
            let newRouter = this.menuChoose[i+1].path
            this.$router.push({path: newRouter})
          }else{
            this.$router.push({path: '/welcome'})
            this.$router.push({path:'/welcome'})
            this.menuChoose = []

          }
        }else if(i>0){
          let newRouter = this.menuChoose[i-1].path
          this.$router.push({path: newRouter})
        }
      }
      this.menuChoose.splice(i,1)
    },
    ...mapMutations({
      setMenuList: 'SET_MENULIST',
      setUserinfo: 'SET_USERINFO',
      setToken: 'SET_TOKEN',
    }),
    getUserInfo(){
      infoGet().then(res=>{
        this.setUserinfo(res)
      })
    },
    codeLoginFunc(){
      let params ={
        code: localStorage.getItem('code'),
        system_name: 'PUBLIC'
      }
      codeLogin(params).then(res=>{
        
        if(res.userInfo){
          this.setUserinfo(res.userInfo)
          this.setToken(res.payload)
          let routerObj = setMenuList(res.rule)
          localStorage.setItem('menuList',JSON.stringify(res.rule))
          this.setMenuList(routerObj)
          this.$cookie.set('barleyUrl', JSON.stringify(res.userInfo.barleyUrl), 1);
          localStorage.removeItem('code')
          this.$router.push({path: '/welcome'})
        }
      })
    },
  },
  components:{
    PersonInfo,tokenRefresh
  }

}
</script>

<style lang="scss">
@import '../assets/scss/common.scss';
@import '../assets/scss/content.scss';
.home{
  width: 100%;
  height: 100%;
  .headerHome{
    z-index: 100;
    background-color: #ffffff;
    height: 56px;
    position: relative;
    box-shadow: 0px 3px 10px rgba(49, 84, 215, 0.1);
    display: flex;
    align-items: center;

      .logo{
        width: 13%;
        min-width: 160px;
        >.icon{
          width: 128px;
          height: 48px;
          position: relative;
          left: 40px;
          cursor: pointer;
        }
      }
      .logoLittle{
        width: 56px;
        text-align: center;
        >.icon{
          width: 32px;
          height: 32px;
          cursor: pointer;
        }

      }

    .userContainer{
      position: absolute;
      right: 0px;
      min-width: 120px;
      display: flex;
      align-items: center;
      height: 100%;
      background-color: #FFFF;
      z-index: 10;
      padding-right: 40px;
      cursor: pointer;
      .btn-user{
        width: 32px;
        height: 32px;
        margin: 8px 0;
      }
      >span{
        color: #030303;
        font-size: 14px;
        margin-left: 8px;
      }
      .el-avatar>img{
        width: 100%;
      }
      &:hover{
        .modulePerson{display: block;}
      }
      .modulePerson{
        position: absolute;
        width: 180px;
        height: 65px;
        right: 35px;
        background-color: #FFF;
        top: 56px;
        display: none;
        box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.04);
        -moz-box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.04);
        >p{
          color: #030303;
          font-size: 14px;
          height: 36px;
          line-height: 36px;
          margin-top: 16px;
          >.icon{
            width: 20px;
            height: 14px;
            margin-right: 5px;
            margin-left: 16px;
            &.active{
              display: none
            }
            &.normal{
              display: inline-block
            }
          }
          
          &:hover{
            background-color: #F7F8FC;
            color: #3135D7;
            .active{
              display: inline-block
            }
            .normal{
              display: none
            }
          }
        }
      }
    }
    .expanDiv{
      width: 64px;
      text-align: center;
      min-width: 64px;
      .btn-expan{
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    .menuSelect{
      width: 74%;
      overflow: auto;
      height: 100%;
      display: flex;
      align-items: center;
      &::-webkit-scrollbar {
        width: 8px;
        height: 6px;
      }
      >div:not(.expanDiv){
        width: 200px;
        height: 100%;
        padding-left:15px;
        min-width: 160px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        >span{
          font-size: 16px;
        }
        >.icon{
          width: 30px;
          height: 18px;
          padding-right: 16px;
          top: 2px;
          position: relative;
        }
        &.active{
          background-color: #F7F8FC;
          border-radius: 16px  16px  0px  0px  ;
          color: #3135D7;
          >.icon{
            border-right: none;
          }
        }
      }
    }
  }
  .contentShow{
    height: calc(100% - 56px);
    background-color: #ffffff;
    width: 100%;
    display: flex;
    .menu:not(.el-menu--collapse) {
      width: 13%;
      min-width: 160px;
    }
    .content{
      width: calc(100% - 64px);
      background-color: #F7F8FC;
      padding: 24px 24px 23px 24px;
    }
    .contentCollapse{
      width: 87%;
      background-color: #F7F8FC;
      padding: 24px 24px 23px 24px;
    }
  }
  // 左侧菜单
  
  .el-menu{
    &.menu{
      padding-top: 32px;
      border-right:none;
      height: 100%;
      overflow: auto;
      &.el-menu--collapse {
        .el-menu-item{min-width: auto;}
      }
    }
    
    .el-submenu__title{
      height: 48px;
      line-height: 48px;
      padding: 0 15px;
      font-size: 16px;
    }
    .el-menu-item{
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #808080;
      min-width: 160px;
      &:hover,
      &.is-active{
        background-color: #F7F8FC;
        color: #3135D7;
      }
     
    }
    .el-submenu.is-opened .el-submenu__title {
      color: #3135D7;
      .iconfont {
        color: #3135D7;
      }
    }
    .iconfont{
      font-size: 24px;
      margin-right: 4px;
    }
    .el-submenu >.el-submenu__title{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #808080;
    }
    /deep/.el-menu-item-group__title{
      padding: 0px 0 0px 20px;
    }
    
  }

}
.el-menu .el-submenu{
  .el-submenu__title{
    &:hover,
    &:active{
      color: #3135D7;
      & i{
        color: #3135D7;
      }
    }
  }
}
.el-menu .el-menu-item{
  &:hover,
    &:active{
      color: #3135D7;
      & i{
        color: #3135D7;
      }
  }
}
.el-menu--vertical .el-menu--popup .el-menu-item {
  height: 48px;
  line-height: 48px;
  color: #808080;
  font-size: 16px;
  font-family:  Noto Sans SC;
  font-weight: 400;
  &:hover{
    background-color: #F7F8FC;
    color: #3135D7;
  }
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
  color: #3135D7;
  background-color: #F7F8FC;
}

</style>